import KeywordSliderItem from './KeywordSliderItem.vue';

export default KeywordSliderItem;
